// @vue/component
export default {
  name: 'ShBreadcrumb',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
